import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGenericContent$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGenericContent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7698d6acce8a98a7ad1118276b08486536026286', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd6cc273f8e24d9a4784676d8b7524e76306bfdca', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '58cf61a3bff671e1b83ca4bf9feaa6d636697ae5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm1 1.5h15v11h-15zM7 9.89A1.11 1.11 0 0 0 5.89 11 1.07 1.07 0 0 0 7 12.11 1.07 1.07 0 0 0 8.11 11 1.11 1.11 0 0 0 7 9.89M9.89 11a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0M15 9.89a1.11 1.11 0 1 0 0 2.22 1.11 1.11 0 0 0 0-2.22", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-generic-content", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-generic-content"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-generic-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGenericContent$1);
            }
            break;
    } });
}

const CosmosIconGenericContent = CosmosIconGenericContent$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGenericContent, defineCustomElement };
